import { TReduxActions } from '../../types/redux';
import { IRealtorInfo } from '../../types/realtorInfo';
import { EActionTypes } from '../../constants/actionTypes/realtorInfo';

export const initialState: IRealtorInfo = {
  isError: false,
  isFetching: false,
  data: null,
};

export const realtorInfoReducer = (state: IRealtorInfo = initialState, action: TReduxActions) => {
  switch (action.type) {
    case EActionTypes.Request:
      return {
        ...state,
        isFetching: true,
        isError: false,
      };
    case EActionTypes.Success:
      return {
        ...state,
        isFetching: false,
        isError: false,
        data: action.payload,
      };
    case EActionTypes.Failure:
      return {
        ...state,
        isFetching: false,
        isError: true,
      };
    default:
      return state;
  }
};
